module.exports = __webpack_public_path__ + "img/publication-4.5a57fead.svg";